import { UserModel } from "./user";
import { Image } from "./common";
import { Charger, ChargerConnector } from "./charger";
import { TagLocation } from "./tag";
import { PricingConditionModel } from "./pricingCondition";

export type LocationInfo = {
  id: string;
  latitude: number;
  longitude: number;
  chargerCount: number;
  chargersInUseCount: number;
  availableConnectors: number;
  workingConnectors: number;
  connectedChargers: Array<string>;
  connectorCount: number; // all connectors
};

export type LocationModel = {
	name: string | undefined;
	description: string | undefined;
	latitude: number;
	longitude: number;
	city: string | undefined;
	street: string | undefined;
	postalCode: string | undefined;
	houseNum: string | undefined;
  phoneNumber: string | undefined;
	hidden: boolean;
  tenantId: string | undefined;
  includeInHubject: boolean;
  allowAnonymous: boolean;
  emailNotification: boolean;
  tags: TagLocation[];
  whitelist: Array<string>;
};

export type Location = LocationModel & {
  id: string | undefined;
};

export type LocationListItem = Location & {
  chargerCount: number;
  chargersInUseCount: number;
  chargingSessionsCount: number;
  chargingSessionsInProgressCount: number;
  distanceInMeters: number;
  availableConnectors: number;
  workingConnectors: number;
  connectedChargers: Array<string>;
  connectorCount: number; // all connectors
  images: Image[];
};

export type LocationWithChargers = LocationListItem & {
  chargers: Charger[];
  currentSessions: ChargingSession[];
};

export enum ChargingSessionState {
  Pending,
  InProgress,
  Parking,
  Finished,
  FailedToSetChargingProfile,
}

export type ChargingSession = {
  id: string;
  startedAt: Date;
  endedAt: Date;
  startedParkingAt: Date;
  length: number;
  consumedWh: number;
  importedWh: number;
  offeredWh: number;
  price: number;
  user: UserModel;
  location: LocationListItem;
  charger: Charger;
  chargingConnector: ChargerConnector;
  chargingConnectorId: string;
  state: ChargingSessionState;
  hasInvoice: boolean;
  errorCause: string;
  idTag: string;
  paid: boolean;
  pricingCondition: PricingConditionModel;
  whitelistAuthentication: boolean;
};
